import React from "react";
import PropTypes from "prop-types";
import Space from "./Space";
import { Subscribe } from "unstated";
import SrpContainer from "../containers/SrpContainer";
import { SpaceShape } from "venuescanner-js/react/shapes";

const NearbySpaces = ({ noResults, isAdmin }) =>
  noResults?.length > 0 && (
    <section className="no-srp-nearby-spaces">
      <h3 className="no-srp-nearby-spaces-title">Nearby Venues</h3>
      <div className="no-srp-nearby-spaces-tiles">
        {noResults.slice(0, 50).map((s) => (
          <Space
            key={s.id}
            space={s}
            ga="no_results_space_tile"
            isAdmin={isAdmin}
          />
        ))}
      </div>
    </section>
  );

NearbySpaces.propTypes = {
  noResults: PropTypes.arrayOf(SpaceShape),
  isAdmin: PropTypes.bool.isRequired,
};

const NearbySpacesContainer = () => (
  <Subscribe to={[SrpContainer]}>
    {({ state: { noResults, isAdmin } }) => (
      <NearbySpaces noResults={noResults.spaces} isAdmin={isAdmin} />
    )}
  </Subscribe>
);

export default NearbySpacesContainer;
